/*
  MIcase - Buscador predictivo propio. Motor.

  Hasta el 11 de agosto de 2026 este codigo viajaba EN LINEA dentro de
  snippets/micase-buscador.liquid. Ese snippet se renderiza desde layout/theme.liquid,
  o sea que el motor entero se repetia dentro del HTML de TODAS las paginas y el
  navegador no lo podia cachear ni una vez. Aqui es un asset: se descarga una sola vez,
  se reutiliza en toda la tienda y el HTML de cada pagina adelgaza otro tanto. Por eso
  los comentarios se quedan enteros - dentro de un asset la documentacion no cuesta
  nada en el HTML.

  El snippet lo carga con defer, asi que este archivo se ejecuta despues de parsear el
  documento: el JSON #mc-search-suggest-data y los formularios de busqueda ya existen
  cuando arranca boot(). La comprobacion de document.readyState se mantiene igual, por
  si alguien lo llegara a cargar de otra forma.

  LO QUE LEE DEL DOM
    #mc-search-suggest-data   JSON que pinta el snippet en Liquid (coleccion, rotulos,
                              modelos calculados del catalogo).
    #mc-search-models-data    lista de modelos para escribir, si existe.
    form[role="search"] input[type="search"][name="q"]   los buscadores a los que se
                              engancha, en el primer barrido y luego por MutationObserver.

  La logica NO se toca aqui: es la misma que estaba en linea, linea por linea.
*/

(function () {
  if (window.MCSearchEngine) return;
  window.MCSearchEngine = true;

  /* --------------------------------------------------------------------
     REGLA 46 · TODO TEXTO QUE SE VE ES EDITABLE (2026-08-18)
     Hasta hoy solo tres rotulos (lt, lc, le) venian del editor de temas y los
     otros doce estaban escritos aqui dentro, donde Sebastian no los alcanza.
     Ahora los doce viajan en el MISMO JSON #mc-search-suggest-data que pinta
     snippets/micase-buscador.liquid con los ajustes settings.mc_buscador_*.
     Los valores de abajo son el ULTIMO recurso: solo salen si el ajuste esta
     vacio o si el JSON no llego. Son palabra por palabra lo que decia antes,
     asi que borrar un ajuste no cambia lo que ve nadie.
     {q} en 'bt' se reemplaza por lo que el visitante escribio.
     -------------------------------------------------------------------- */
  var cfg = {
    c: 'fundas-para-xiaomi-redmi-poco',
    lt: 'Tus modelos',
    lc: 'Empieza por tu modelo',
    le: 'Primero, elige tu modelo',
    nm: 'No sé cuál es mi modelo',
    nmu: '/pages/cual-es-tu-xiaomi',
    bt: 'Buscar “{q}” en todo el catálogo',
    mk: 'MODELO',
    vc: 'Ver productos compatibles',
    lp1: 'También coincide por producto',
    lp2: 'Coincidencias del catálogo',
    pf: 'Producto MIcase',
    va1: 'Buscar modelo o producto en todo el catálogo',
    va2: 'Ver todos los resultados',
    st: 'Buscando modelos y productos…',
    e0: 'No encontramos una coincidencia exacta.',
    e1: 'No pudimos cargar las sugerencias. La búsqueda completa sí está disponible.',
    m: []
  };
  var cfgData = document.getElementById('mc-search-suggest-data');
  if (cfgData) {
    try {
      var cfgRaw = JSON.parse(cfgData.textContent || '{}');
      if (cfgRaw && typeof cfgRaw === 'object') {
        /* Un solo bucle: cualquier clave de texto que venga con algo dentro pisa
           al valor de reserva. Asi anadir un ajuste manana es tocar Liquid y el
           schema, no este archivo. 'm' se trata aparte porque es una lista. */
        var claves = ['c', 'lt', 'lc', 'le', 'nm', 'nmu', 'bt', 'mk', 'vc',
                      'lp1', 'lp2', 'pf', 'va1', 'va2', 'st', 'e0', 'e1'];
        for (var ci = 0; ci < claves.length; ci++) {
          var ck = claves[ci];
          if (typeof cfgRaw[ck] === 'string' && cfgRaw[ck] !== '') cfg[ck] = cfgRaw[ck];
        }
        if (cfgRaw.m && cfgRaw.m.length) cfg.m = cfgRaw.m;
      }
    } catch (e) { }
  }
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var uid = 0;
  var models = [];
  var modelData = document.getElementById('mc-search-models-data');
  if (modelData) {
    try { models = JSON.parse(modelData.textContent || '[]'); } catch (e) { models = []; }
  }

  var handlePorNombre = {};
  cfg.m.forEach(function (par) {
    if (par && par[0] && par[1]) handlePorNombre[String(par[0]).toLowerCase()] = par[1];
  });

  // handleize CRUDO, el mismo que aplica Shopify a la etiqueta para filtrar la
  // coleccion. Aqui NO se traduce el + a ' plus ': eso es para valores de opcion
  // (ver snippets/micase-modelo.liquid), y en una URL apuntaria a una etiqueta
  // que no existe.
  function mcHandle(value) {
    var text = String(value == null ? '' : value).toLowerCase();
    if (text.normalize) text = text.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return text.replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  function modelHandle(model) {
    if (!model) return '';
    var directo = model.h || model.handle;
    if (directo) return String(directo);
    var nombre = model.name || model.n || '';
    return handlePorNombre[String(nombre).toLowerCase()] || mcHandle(nombre);
  }

  // Destino real de un modelo: la coleccion filtrada por su etiqueta. Nunca /search.
  function modelUrl(handle) {
    if (!handle) return '';
    return root + 'collections/' + cfg.c + '/' + handle;
  }

  function leeJSON(clave) {
    try { return JSON.parse(window.localStorage.getItem(clave) || 'null'); } catch (e) { return null; }
  }

  // 'micase_modelo' lo escribe micase-detecta.liquid; el historial lo escribe este
  // mismo snippet cuando alguien pulsa una sugerencia de modelo.
  function modelosPropios() {
    var lista = [];
    var vistos = {};
    function mete(entrada) {
      if (!entrada) return;
      var nombre = entrada.n || entrada.name;
      var handle = entrada.h || entrada.handle || (nombre ? mcHandle(nombre) : '');
      if (!nombre || !handle || vistos[handle]) return;
      vistos[handle] = 1;
      lista.push({ n: nombre, h: handle });
    }
    mete(leeJSON('micase_modelo'));
    var previos = leeJSON('micase_modelos_recientes');
    if (previos && previos.length) Array.prototype.forEach.call(previos, mete);
    return lista.slice(0, 4);
  }

  function recuerda(nombre, handle) {
    if (!nombre || !handle) return;
    var previos = leeJSON('micase_modelos_recientes');
    if (!previos || !previos.length) previos = [];
    var limpios = [];
    Array.prototype.forEach.call(previos, function (item) {
      if (item && item.h && item.h !== handle) limpios.push({ n: item.n, h: item.h });
    });
    limpios.unshift({ n: nombre, h: handle });
    try { window.localStorage.setItem('micase_modelos_recientes', JSON.stringify(limpios.slice(0, 4))); } catch (e) { }
  }

  function element(tag, className, textValue) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (typeof textValue === 'string') node.textContent = textValue;
    return node;
  }

  function searchUrl(term) {
    return root + 'search?type=product&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&options%5Bfields%5D=title%2Cvendor%2Cproduct_type%2Cvariants.title&q=' + encodeURIComponent(term);
  }

  function normalize(value) {
    var text = String(value || '').toLowerCase();
    if (text.normalize) text = text.normalize('NFD').replace(/[̀-ͯ]/g, '');
    return text.replace(/\+/g, ' plus ').replace(/[^a-z0-9]+/g, ' ').trim();
  }

  function modelMatches(term) {
    var query = normalize(term);
    if (query.length < 2) return [];
    var tokens = query.split(/\s+/).filter(Boolean);
    return models.map(function (model) {
      var name = model && model.name ? model.name : '';
      var comparable = normalize(name);
      var matches = tokens.every(function (token) { return comparable.indexOf(token) !== -1; });
      if (!matches) return null;
      var handle = modelHandle(model);
      if (!handle) return null;
      var score = comparable.indexOf(query) === 0 ? 0 : comparable.indexOf(query) >= 0 ? 1 : 2;
      return { name: name, handle: handle, score: score, length: comparable.length };
    }).filter(Boolean).sort(function (a, b) {
      return a.score - b.score || a.length - b.length || a.name.localeCompare(b.name, 'es');
    }).slice(0, 5);
  }

  function priceText(product) {
    if (!product || product.price == null) return '';
    if (typeof product.price === 'string' && !/^\d+(?:\.\d+)?$/.test(product.price)) return product.price;
    try {
      var numericPrice = Number(product.price);
      return new Intl.NumberFormat('es-CO', { style: 'currency', currency: 'COP', maximumFractionDigits: 0 }).format(numericPrice);
    } catch (e) { return ''; }
  }

  function enhance(input) {
    if (!input || input.dataset.mcSearchReady === 'true') return;
    var form = input.closest('form[role="search"]');
    if (!form) return;

    input.dataset.mcSearchReady = 'true';
    form.classList.add('mc-search-scope');
    var panel = element('div', 'mc-search-predict');
    panel.id = 'mc-search-predict-' + (++uid);
    panel.setAttribute('role', 'listbox');
    panel.hidden = true;
    form.appendChild(panel);
    input.setAttribute('aria-controls', panel.id);

    var timer = 0;
    var controller = null;
    var active = -1;

    function options() {
      return Array.prototype.slice.call(panel.querySelectorAll('[role="option"]'));
    }

    function show() {
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function hide() {
      panel.hidden = true;
      input.setAttribute('aria-expanded', 'false');
      active = -1;
    }

    function pastilla(nombre, handle) {
      var link = element('a', '', nombre);
      link.href = modelUrl(handle);
      link.addEventListener('click', function () { recuerda(nombre, handle); });
      return link;
    }

    function renderSugerencias() {
      panel.innerHTML = '';
      var propios = modelosPropios();
      var usados = {};
      if (propios.length) {
        panel.appendChild(element('span', 'mc-search-predict__label', cfg.lt));
        var grupoPropio = element('div', 'mc-search-predict__shortcuts');
        propios.forEach(function (item) {
          usados[item.h] = 1;
          grupoPropio.appendChild(pastilla(item.n, item.h));
        });
        panel.appendChild(grupoPropio);
      }
      var delCatalogo = [];
      cfg.m.forEach(function (par) {
        if (!par || !par[0] || !par[1] || usados[par[1]]) return;
        delCatalogo.push(par);
      });
      if (delCatalogo.length) {
        panel.appendChild(element('span', 'mc-search-predict__label', cfg.lc));
        var grupoCatalogo = element('div', 'mc-search-predict__shortcuts');
        delCatalogo.forEach(function (par) {
          grupoCatalogo.appendChild(pastilla(par[0], par[1]));
        });
        panel.appendChild(grupoCatalogo);
      }
      var model = element('a', 'mc-search-predict__all', cfg.nm);
      model.href = cfg.nmu;
      model.appendChild(element('b', '', '→'));
      panel.appendChild(model);
      show();
    }

    function renderStatus(message, term) {
      panel.innerHTML = '';
      panel.appendChild(element('p', 'mc-search-predict__status', message));
      if (term) {
        var all = element('a', 'mc-search-predict__all', cfg.bt.replace('{q}', term));
        all.href = searchUrl(term);
        all.appendChild(element('b', '', '→'));
        panel.appendChild(all);
      }
      show();
    }

    function renderResults(products, term) {
      var matches = modelMatches(term);
      panel.innerHTML = '';
      if (matches.length) {
        panel.appendChild(element('span', 'mc-search-predict__label', cfg.le));
        matches.forEach(function (model) {
          var modelLink = element('a', 'mc-search-predict__model');
          modelLink.href = modelUrl(model.handle);
          modelLink.addEventListener('click', function () { recuerda(model.name, model.handle); });
          modelLink.setAttribute('role', 'option');
          modelLink.setAttribute('aria-selected', 'false');
          modelLink.appendChild(element('span', 'mc-search-predict__model-mark', cfg.mk));
          var modelCopy = element('span', 'mc-search-predict__copy');
          modelCopy.appendChild(element('span', 'mc-search-predict__title', model.name));
          modelCopy.appendChild(element('span', 'mc-search-predict__price', cfg.vc));
          modelLink.appendChild(modelCopy);
          modelLink.appendChild(element('b', 'mc-search-predict__arrow', '→'));
          panel.appendChild(modelLink);
        });
      }
      if (products.length) {
        panel.appendChild(element('span', 'mc-search-predict__label', matches.length ? cfg.lp1 : cfg.lp2));
      }
      products.forEach(function (product) {
        var link = element('a', 'mc-search-predict__item');
        link.href = product.url || searchUrl(term);
        link.setAttribute('role', 'option');
        link.setAttribute('aria-selected', 'false');

        var imageUrl = product.featured_image && product.featured_image.url;
        if (!imageUrl && product.image) imageUrl = product.image;
        if (imageUrl) {
          var image = element('img', 'mc-search-predict__image');
          image.src = imageUrl;
          image.alt = '';
          image.width = 54;
          image.height = 54;
          image.loading = 'lazy';
          link.appendChild(image);
        }

        var copy = element('span', 'mc-search-predict__copy');
        copy.appendChild(element('span', 'mc-search-predict__title', product.title || cfg.pf));
        var price = priceText(product);
        if (price) copy.appendChild(element('span', 'mc-search-predict__price', price));
        link.appendChild(copy);
        panel.appendChild(link);
      });

      var all = element('a', 'mc-search-predict__all', matches.length ? cfg.va1 : cfg.va2);
      all.href = searchUrl(term);
      all.appendChild(element('b', '', '→'));
      panel.appendChild(all);
      show();
    }

    function request(term) {
      if (controller) controller.abort();
      controller = window.AbortController ? new AbortController() : null;
      renderStatus(cfg.st);
      var url = root + 'search/suggest.json?q=' + encodeURIComponent(term)
        + '&resources%5Btype%5D=product&resources%5Blimit%5D=5'
        + '&resources%5Boptions%5D%5Bunavailable_products%5D=last'
        + '&resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.title';
      fetch(url, controller ? { signal: controller.signal } : {})
        .then(function (response) { if (!response.ok) throw new Error('search'); return response.json(); })
        .then(function (data) {
          if (input.value.trim() !== term) return;
          var products = data && data.resources && data.resources.results && data.resources.results.products;
          products = products || [];
          if (products.length || modelMatches(term).length) renderResults(products, term);
          else renderStatus(cfg.e0, term);
        })
        .catch(function (error) {
          if (error && error.name === 'AbortError') return;
          if (modelMatches(term).length) renderResults([], term);
          else renderStatus(cfg.e1, term);
        });
    }

    input.addEventListener('focus', function () {
      var term = input.value.trim();
      if (term.length >= 2) request(term); else renderSugerencias();
    });
    input.addEventListener('input', function () {
      window.clearTimeout(timer);
      active = -1;
      var term = input.value.trim();
      if (term.length < 2) { renderSugerencias(); return; }
      timer = window.setTimeout(function () { request(term); }, 180);
    });
    input.addEventListener('keydown', function (event) {
      var list = options();
      if (event.key === 'Escape') { hide(); return; }
      if (!list.length || (event.key !== 'ArrowDown' && event.key !== 'ArrowUp' && event.key !== 'Enter')) return;
      if (event.key === 'Enter' && active >= 0) {
        event.preventDefault();
        list[active].click();
        return;
      }
      if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
        event.preventDefault();
        if (event.key === 'ArrowDown') active = (active + 1) % list.length;
        else active = (active - 1 + list.length) % list.length;
        list.forEach(function (item, index) { item.setAttribute('aria-selected', index === active ? 'true' : 'false'); });
      }
    });
    document.addEventListener('pointerdown', function (event) {
      if (!form.contains(event.target)) hide();
    });
  }

  function scan(rootNode) {
    var scope = rootNode && rootNode.querySelectorAll ? rootNode : document;
    Array.prototype.forEach.call(scope.querySelectorAll('form[role="search"] input[type="search"][name="q"]'), enhance);
  }

  function boot() {
    scan(document);
    if (window.MutationObserver) {
      new MutationObserver(function (records) {
        records.forEach(function (record) {
          Array.prototype.forEach.call(record.addedNodes || [], function (node) {
            if (node.nodeType === 1) scan(node);
          });
        });
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
